import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiSelectStyles = (variables: Variables) => ({
    styleOverrides: {
        select: {
            padding: variables.padding.inputsDefault,
        },
    },
});

export default createMuiSelectStyles;
